import { cast } from 'redpoints-front-common/helpers';

import { filtersCastOptions } from '../../../config/shortenerResolutionConfiguration';

export const getFiltersAppliedFromValidQueryParams = ({
  availableDomains,
  queryParams,
  selectedFilterByCustomer,
}) => {
  const castedQueryParams = cast(filtersCastOptions)(queryParams);

  const domain = getDomainByUrl({
    domains: availableDomains,
    url: castedQueryParams.domainUrl,
  });

  const filterByCustomer =
    castedQueryParams.filterByCustomer ?? selectedFilterByCustomer;

  return {
    domain,
    filterByCustomer,
  };
};

export const getDomainByUrl = ({ domains, url }) =>
  domains.find(domain => domain.url === url) ?? null;
